export const API_URL_WHALESHARK_VAULT_CAROUSEL = "/whaleshark/vault/carousel/";
export const API_URL_WHALESHARK_HIGHLIGHTS = "/whaleshark/highlights/";
export const API_URL_WHALESHARK_REPORT = "/whaleshark/vault/report/";
export const API_URL_WHALESHARK_PARTNER = "/whaleshark/partners/";
export const API_URL_WHALESHARK_FGINDEX = "/whaleshark/fearGreedIndex/";
export const API_URL_WHALESHARK_GLANCE = "/whaleshark/glances/";
export const API_URL_WHALESHARK_CALENDAR = "/whaleshark/calendars/";
export const API_URL_WHALESHARK_BENEFITS = "/whaleshark/benefits/";
export const API_URL_WHALESHARK_ARTICLES = "/whaleshark/articles/";
